import { ButtonProps } from 'UI/Button/Button.types';
import * as S from './NextButton.styles';

const NextButton = (props: ButtonProps): JSX.Element => <S.Container {...props} />;

export default NextButton;
